import { Component, OnInit } from '@angular/core';
import { DataHelper } from '../../helpers/data.helper';
import { UiHelper } from '../../helpers/ui.helper';
import { DataService } from '../../services/data.service';
import { UserHelper } from '../../helpers/user.helper';
import { Subscription } from 'rxjs';

@Component({
  selector: 'cashout-new',
  templateUrl: './cashout.new.html',
  styleUrls: ['./cashout.new.sass'],
})
export class CashoutNew implements OnInit {
  possibleWinning = '9.11€';
  isLive = true;
  stake = '2.00€';
  matchData = [
    {
      name: '3WAY - 1',
      oddName: '3WAY - 13WAY - 13WAY - 13WAY - 13WAY - 13WAY - 1',
      oddTeam: 'Fenerbahçe',
      score: '1:0',
      minutes: '45',
      description: 'Fenerbahçe - Galatasaray FC - 1:0 Score 0:0 (at 35’)',
      awayTeam: 'Galatasaray FCFenerbahçeFenerbahçeFenerbahçeFenerbahçeFenerbahçe',
      homeTeam: 'Fenerbahçe',
      homeTeamScore: '1',
      awayTeamScore: '0',
      homeTeamScoreHT: '0',
      awayTeamScoreHT: '0',
      goalMin: '35',
      odds: '2.50',
    },
  ];

  isMobileView = false;
  private subscriptionsToStopOnDestroy: Subscription[] = [];
  slipIsOpen = '0';

  constructor(public _DataHelper: DataHelper, public _UiHelper: UiHelper, private _DataService: DataService, public _UserHelper: UserHelper) {}

  ngOnInit() {
    this._DataService.activeList.getSlipCashOutValues = true;
    if (this.isMobileView) {
      if (this._UserHelper.isSignedIn) {
        this._DataService.removeDataGetter('getSlipCashOutList');
        this._DataService.setDataGetter('getSlipCashOutList', 15);
      }
      {
        this.subscriptionsToStopOnDestroy.push(
          this._UserHelper.signInListener.subscribe(s => {
            if (s === true) {
              this._DataService.setDataGetter('getSlipCashOutList', 15);
            } else {
              this._DataService.removeDataGetter('getSlipCashOutList');
              this._DataService.removeDataGetter('getSlipCashOutValues');
            }
          })
        );
      }
    } else {
      if (this._UserHelper.isSignedIn) {
        this._DataService.setDataGetter('getSlipCashOutList', 15);
      } else {
        this._UiHelper.b3000SetRightMenuState('open');
        this.subscriptionsToStopOnDestroy.push(
          this._UserHelper.signInListener.subscribe(s => {
            if (s === true) {
              this._DataService.setDataGetter('getSlipCashOutList', 15);
            } else {
              this._DataService.removeDataGetter('getSlipCashOutList');
              this._DataService.removeDataGetter('getSlipCashOutValues');
            }
          })
        );
      }
    }

    this._UiHelper.setNavbarTitle('Cashout', true);
  }

  ngOnDestroy() {
    for (const subscription of this.subscriptionsToStopOnDestroy) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }
  }

  getLiveAny(_data) {
    try {
      return _data.filter(i => i.liveTime && i.liveTime !== '').length > 0;
    } catch (e) {
      return false;
    }
  }
}
